import React, {Component} from 'react';
import {Document, Page} from "react-pdf/dist/entry.webpack";

class GroceryContainer extends Component {
  state = {
    numPages: null,
    pageNumber: 2,
  };

  onDocumentLoadSuccess = ({numPages}) => {
    this.setState({numPages});
  };

  goToPrevPage = () => {
    if (this.state.pageNumber > 2) {
      this.setState(state => ({pageNumber: state.pageNumber - 1}));
    }
  };

  goToNextPage = () =>
    this.setState(state => ({pageNumber: state.pageNumber + 1}));

  render() {
    const {pageNumber, numPages} = this.state;

    return (
      <section>
        <div className="section-body">
          <div className="row">
            <div className="col-lg-12">
              <div className="card ">
                <div className="card-head">
                  <header>Grocery management is coming soon!</header>
                </div>
                <div className="card-body">
                  <nav>
                    {this.state.pageNumber > 2 ?
                      <button onClick={this.goToPrevPage}>Prev</button>
                      : ''
                    }
                    &nbsp;
                    <button onClick={this.goToNextPage}>Next</button>
                    &nbsp;
                    {pageNumber} of {numPages}&nbsp;
                  </nav>
                  <br/>
                  <div>
                    <Document
                      file='/assets/doc/directory.pdf'
                      onLoadSuccess={this.onDocumentLoadSuccess}
                      loading={"Loading groceries..."}
                    >
                      <Page pageNumber={pageNumber} width={600}/>
                    </Document>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default GroceryContainer;
